import React from 'react';
import prospectImage from '../../../images/woman-unsuccess.png';
import StaticPages from '..';

export function SchedulingUnavailable() {
  return (
    <StaticPages
      mainText='Scheduling Unavailable'
      prospectImage={prospectImage}
      secondaryText={
        <>
          {
            "We're currently unable to load available time slots. Please check back"
          }
          <br />
          later or reach out to your recruiter for assistance.
        </>
      }
    />
  );
}
